import { TextImageBlockProps } from '../../components/HelpPages/organisms/TextAndImageBlock';
import { TextImageBlockData } from '../../types/optimizely/blocks/textImageBlockHP';

export const mapToTextImageProps = (
	data: TextImageBlockData,
): TextImageBlockProps => {
	const {
		title,
		textEditor,
		backgroundColor,
		fontColor,
		imagePosition,
		image,
		anchorId,
	} = data;

	const textProps = {
		title: title.value,
		summary: textEditor.value,
		backgroundColor: backgroundColor.value,
		fontColor: fontColor.value,
	};

	const imageProps = {
		src: image?.value?.url || '',
		description: image?.expandedValue?.description?.value || '',
		/////////////  TO DO ///////////////

		// ratio: image.expandedValue.ratio

		/////////////  TO DO ///////////////
	};

	return {
		text: textProps,
		image: imageProps,
		anchorId,
		imagePosition: imagePosition.value,
	};
};
